import { useNavigate } from "react-router";

// mapping fields -> label
const fieldLabels = {
    gender: "Gender",
    email: "Email",
    phone: "Phone",
    school: "School",
    grad_year: "Graduation Year",
    sport: "Sport",
    position: "Position",
    previous_concussion_count: "Previous Concussion Count",
};

const AthleteCard = ({ athlete, onClick, showSubtleText = false }) => {
    const navigate = useNavigate();
    const { first_name, last_name, dob, ...rest } = athlete.athlete_info;

    const formattedDate = dob
        ? new Date(dob).toLocaleDateString(undefined, {
              year: "numeric",
              month: "short",
              day: "numeric",
          })
        : "—";

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={onClick}
            className="
            group bg-white border-2 border-primary rounded-lg p-4
            transition transform cursor-pointer
            hover:-translate-y-1  hover:border-[#3EB1A6]
            active:ring-2 active:ring-indigo-500
            "
        >
            <div className="flex justify-between items-center mb-2">
                <h5 className="text-2xl font-bold capitalize text-gray-900 flex items-center gap-2">
                    {first_name} {last_name}
                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/athletes/edit`, { state: { athlete } });
                        }}
                        className="hover:text-teal-600 transition-colors"
                        aria-label="Edit athlete"
                    >
                        <svg
                            className="w-5 h-5"
                            aria-hidden="true"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g
                                fill="none"
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                            >
                                <path d="M7 7H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-1" />
                                <path d="M20.385 6.585a2.1 2.1 0 0 0-2.97-2.97L9 12v3h3zM16 5l3 3" />
                            </g>
                        </svg>
                    </button>
                </h5>
                <p className="text-gray-600">{formattedDate}</p>
            </div>
            <div className="text-black space-y-1">
                {/* This text shows up only on the athletes page. It should be centered on mobile, but right-aligned on anything larger */}
                {Object.keys(rest)
                    .filter((key) => fieldLabels[key])
                    .map((key) => (
                        <p>
                            <strong>{fieldLabels[key]}:</strong>{" "}
                            {athlete.athlete_info[key] || "N/A"}
                        </p>
                    ))}

                {showSubtleText && (
                    <div className="flex items-center flex-col sm:flex-row justify-between sm:items-start pt-4 sm:pt-0">
                        <div className="flex text-[#3EB1A6] font-semibold sm:text-right sm:ml-auto">
                            <p>Launch the IISS </p>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                className="size-6"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="m8.25 4.5 7.5 7.5-7.5 7.5"
                                />
                            </svg>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AthleteCard;
